export const detailColumns = [
  {
    title: "材料编号",
    width: 150,
    key: "materialBizNo",
  },
  {
    title: "材料名称",
    width: 180,
    key: "materialName",
    dataIndex: "materialName",
  },
  {
    title: "规格型号",
    width: 200,
    key: "materialModel",
    dataIndex: "materialModel",
  },
  {
    title: "品牌",
    width: 200,
    key: "materialCategoryBrandName",
    dataIndex: "materialCategoryBrandName",
  },
  {
    title: "结算单位",
    width: 150,
    key: "materialUnitName",
    dataIndex: "materialUnitName",
  },
  {
    title: "销售单价（含税）",
    width: 150,
    key: "unitPrice",
    dataIndex: "unitPrice",
  },
  {
    title: "税率",
    width: 150,
    key: "taxRate",
    dataIndex: "taxRate",
  },
  {
    title: "实际使用",
    width: 150,
    key: "useNumber",
    dataIndex: "useNumber",
  },
  {
    title: "销售总价（含税）",
    width: 150,
    key: "totalPrice",
    dataIndex: "totalPrice",
    slots: { customRender: "totalPrice" },
  },
  {
    title: "税额",
    width: 150,
    key: "taxPrice",
    dataIndex: "taxPrice",
    slots: { customRender: "taxPrice" },
  },
];
